var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148565",
    "data-name": "Rectangle 148565",
    width: 30,
    height: 30,
    transform: "translate(1321 57)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "poll",
    transform: "translate(-1321 -57)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11696",
    "data-name": "Group 11696",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    d: "M2,1.3a.7.7,0,0,0-.7.7V4a.7.7,0,0,0,.7.7H13a.7.7,0,0,0,.7-.7V2a.7.7,0,0,0-.7-.7H2M2,0H13a2,2,0,0,1,2,2V4a2,2,0,0,1-2,2H2A2,2,0,0,1,0,4V2A2,2,0,0,1,2,0Z",
    transform: "translate(1325 60)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    d: "M2,1.3a.7.7,0,0,0-.7.7V4a.7.7,0,0,0,.7.7H22a.7.7,0,0,0,.7-.7V2a.7.7,0,0,0-.7-.7H2M2,0H22a2,2,0,0,1,2,2V4a2,2,0,0,1-2,2H2A2,2,0,0,1,0,4V2A2,2,0,0,1,2,0Z",
    transform: "translate(1325 69)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    d: "M2,1.3a.7.7,0,0,0-.7.7V4a.7.7,0,0,0,.7.7H17a.7.7,0,0,0,.7-.7V2a.7.7,0,0,0-.7-.7H2M2,0H17a2,2,0,0,1,2,2V4a2,2,0,0,1-2,2H2A2,2,0,0,1,0,4V2A2,2,0,0,1,2,0Z",
    transform: "translate(1325 78)",
    fill: "#0c0c0b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.9a73faae.svg";
export { ForwardRef as ReactComponent };